export const SLIDER_VALUES = {
  MARKS: [0, 20, 50, 100],
};
